import React from "react";
import { useLang } from "../LanguageContext";
import ScrollReveal from "./ScrollReveal";
import SkillsTab from "./SkillsTab";

export default function CapabilitiesSection() {
  const { lang } = useLang();

  return (
    <section className="capabilities-section">
      <div className="section-inner">
        <ScrollReveal>
          <h2 className="section-heading">
            {lang === "en" ? "Capabilities" : "Compétences"}
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={200}>
          <SkillsTab />
        </ScrollReveal>
      </div>
    </section>
  );
}
